
import { Component, OnInit, OnDestroy } from '@angular/core';
import { PHBHPFeaturePackageConsumptionService } from './../ph-bhp-feature-package-consumption.service';
import { Department } from '../Models/Department';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Ward } from './../Models/Ward';
import { ConsumptionPeriod } from './../Models/ConsumptionPeriod';
import { Router } from '@angular/router';
import { PHBHPLayoutPackageService } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { Subscription, forkJoin } from 'rxjs';
import { AppConfig } from 'src/app/app.config';
import { TranslationKeys } from 'ph-bhp-localization';

@Component({
  selector: 'lib-ph-bhp-new-consumption',
  templateUrl: './ph-bhp-new-consumption.component.html',
  styleUrls: ['./ph-bhp-new-consumption.component.css']
})
export class PhBhpNewConsumptionComponent implements OnInit, OnDestroy {
  nrSelect;
  subscription: Subscription;
  emitData: any = {
    key: "",
    val: ""
  }

  modalRef: BsModalRef;
  userData: any;
  submitted = false;
  consumptionData: any;
  departmentDetail: Array<Department> = [];
  consumptionPeriodDetail: Array<ConsumptionPeriod> = [];
  consumptionConfigDetail: any;
  consumptionConfigs: any[];
  deptName: string;
  consumptionID: any;
  wardDetails: Array<Ward> = [];
  selectedWard: Ward;
  wardID: number;
  deptID: number;
  consumptionForm: UntypedFormGroup;
  wardTrigger: boolean = true;
  deptTrigger: boolean = true;
  department: Array<Department> = [];
  departmentID: number;
  wards: Array<Ward> = []
  wardWarningMessage: boolean = false;
  navTo;
  currentYear;
  previousYears: number[] = [];
  translationKeys: typeof TranslationKeys = TranslationKeys;

  get currentSelectedDepartmentName(): string | null {
    // form only contains id, so get name from details
    const id = this.consumptionForm.get('departmentID').value;
    const dept = this.departmentDetail.find(dept => dept.departmentID == id);
    return dept == null ? null : dept.departmentName;
  }

  constructor(
    private consumptionService: PHBHPFeaturePackageConsumptionService,
    private router: Router,
    private layoutService: PHBHPLayoutPackageService,
    public appConfig: AppConfig,
    private modalService: BsModalService) { }

  ngOnInit() {
    this.appConfig.viewconsumption = true;
    this.appConfig.editconsumption = false;
    this.appConfig.showconsumption = false
    this.consumptionForm = new UntypedFormGroup({
      year: new UntypedFormControl("", Validators.compose([Validators.required, Validators.maxLength(4)])),
      departmentID: new UntypedFormControl("", Validators.compose([Validators.required])),
      wardID: new UntypedFormControl("", Validators.compose([Validators.required])),
      wardName: new UntypedFormControl(""),
    });


    if (this.layoutService.institutionID) {
      this.userData = this.appConfig.userData;
      this.loadWardsAndConsumptionConfigData();
    }

    this.subscription = this.layoutService.institutionIDSubject.asObservable().subscribe((res) => {
      this.appConfig.showconsumption = false;
      this.userData = this.appConfig.userData;
      this.loadWardsAndConsumptionConfigData();
    });

  }

  onChildNavigate(event: any) {
    if (event.key === 'start') {
      this.router.navigate(['consumption/new/start']);
    }
  }

  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
  }

  loadWardsAndConsumptionConfigData() {
    this.layoutService.showLoader = true;

    forkJoin([
      this.consumptionService.getWardsAndDepartments(this.layoutService.institutionID),
      this.consumptionService.getConsumptionConfigByInstitutionId(this.layoutService.institutionID)
    ]).subscribe(
      ([wardsAndDepartments, consumptionConfigs]) => {
        this.layoutService.showLoader = false;

        this.handleWardsAndDepartments(wardsAndDepartments);

        this.handleConsumptionConfigs(consumptionConfigs);

        this.loadConsumptionConfigs();
      },
      error => {
        this.layoutService.showLoader = false;
        console.error('Error loading wards and consumption config data', error);
      }
    );
  }

  private handleWardsAndDepartments(wardsAndDepartments: any) {
    if (!wardsAndDepartments) {
      this.wardWarningMessage = true;
      return;
    }

    this.wardDetails = wardsAndDepartments['wardsDetails'] || [];
    this.wardDetails = this.wardDetails.filter((ward) => ward.isActive);
    this.departmentDetail = wardsAndDepartments['departments'] || [];

    this.wardWarningMessage = this.wardDetails.length === 0;

    if (!this.wardWarningMessage) {
      this.selectedWard = this.wardDetails[0];
      let department = this.departmentDetail.find((res) => res.departmentID == this.selectedWard.departmentID)
      this.consumptionForm.patchValue({
        departmentID: department,
        wardID: this.selectedWard,
        wardName: this.selectedWard?.wardName || ''
      });
    }
  }

  private handleConsumptionConfigs(consumptionConfigs: any) {
    this.consumptionConfigs = consumptionConfigs.consumptionConfigs || [];

    const currentYear = new Date().getFullYear();
    const lastTenYears = Array.from({ length: 11 }, (_, i) => currentYear - i);

    if (this.consumptionConfigs.length === 0) {
      this.currentYear = currentYear;
      this.nrSelect = this.currentYear;
      this.previousYears = [this.currentYear];
    } else {
      this.previousYears = this.consumptionConfigs
        .filter(config => lastTenYears.includes(config.year))
        .sort((a, b) => b.year - a.year)
        .map(x => x.year);

      this.currentYear = this.previousYears.includes(currentYear)
        ? currentYear
        : this.previousYears[0];
      this.nrSelect = this.currentYear;
    }
  }

  loadConsumptionConfigs() {
    this.consumptionConfigDetail = this.consumptionService.getConsumptionYearConfiguration(this.consumptionConfigs, this.nrSelect);

    if (!this.consumptionConfigDetail) {
      this.consumptionConfigDetail = null;
    } else {
      this.consumptionConfigDetail.period = this.consumptionConfigDetail.period.toLocaleLowerCase();
      if (this.consumptionConfigDetail.period === "m") {
        this.navTo = "m";
      } else if (this.consumptionConfigDetail.period === "y") {
        this.navTo = "y";
      } else if (this.consumptionConfigDetail.period === "q") {
        this.navTo = "q";
      } else {
        this.consumptionConfigDetail = null;
      }
    }
  }

  onYearChange(event: number) {
    this.nrSelect = event;
    this.loadConsumptionConfigs();
  }

  onWardChange(event: Ward) {
    this.wardTrigger = true;
    this.selectedWard = event;
    this.wardID = event.wardID;
    if (this.wardTrigger) {
      this.deptTrigger = false;
      if (this.wardID) {
        this.wardWarningMessage = false;
        var getDepartment = this.departmentDetail.find((res) => res.departmentID == event.departmentID)
        this.consumptionForm.patchValue({ departmentID: getDepartment, wardID: event, wardName: event.wardName });
        this.deptTrigger = true;
      }
      else {
        this.wardWarningMessage = true;
      }
    }
  }

  onSubmit(value, cancelmodal) {
    this.submitted = true;
    if (this.consumptionForm.invalid) {
      return;
    }
    this.saveConsumption(value, cancelmodal);
  }

  saveConsumption(value, cancelmodal) {
    var value = this.consumptionForm.value;
    var data = {
      period: this.consumptionConfigDetail.period.toLowerCase(),
      wardID: value.wardID.wardID,
      departmentID: value.departmentID.departmentID,
      departmentTypeID: value.wardID.departmentTypeID,
      year: value.year,
      institutionID: this.layoutService.institutionID,
      createdBy: this.userData.userId,
      consumptionPeriodID: null
    }

    if (this.layoutService.institutionID) {
      this.layoutService.showLoader = true;
      this.consumptionService.createNewConsumption(data).subscribe((res: any) => {
        this.layoutService.showLoader = false;
        this.consumptionData = res;
        if (this.consumptionData.consumptionID == 0) {
          this.appConfig.showconsumption = true;
        }
        else if (this.consumptionData.existingConsumptionID) {
          this.appConfig.showconsumption = false;
          this.modalRef = this.modalService.show(cancelmodal, Object.assign({}, { class: 'w-420' })
          )
        }
      });
    }
  }

  openviewconsumption() {
    this.router.navigate([`/consumption/new/start/${this.consumptionConfigDetail.period.toLowerCase()}/${this.consumptionData.existingConsumptionID}`]);
    this.modalRef.hide();
  }

  onClickWardHandler(event: Event) {
    this.layoutService.showLoader = true;
    this.consumptionService.getWardsAndDepartments(this.layoutService.institutionID).subscribe((wardsAndDepartments) => {
      if (wardsAndDepartments && wardsAndDepartments['wardsDetails']) {
        this.wardDetails = wardsAndDepartments['wardsDetails'] || [];
        this.wardDetails = this.wardDetails.filter((ward) => ward.isActive);
      };

      if (wardsAndDepartments && wardsAndDepartments['departments']) {
        this.departmentDetail = wardsAndDepartments['departments'] || [];
      };

      this.wardWarningMessage = this.wardDetails.length === 0;
      if (!this.wardDetails.find((ward) => ward.wardID == this.consumptionForm.get('wardID').value.wardID)) {
        this.selectedWard = this.wardDetails[0];
        let department = this.departmentDetail.find((res) => res.departmentID == this.selectedWard.departmentID)
        this.consumptionForm.patchValue({
          departmentID: department,
          wardID: this.selectedWard,
          wardName: this.selectedWard?.wardName || ''
        });
      }
    }, (error) => { }, () => { this.layoutService.showLoader = false });
  }

  getDepartmentTypeName(ward: any) {
    return ward.departmentTypeID === 1 ? '' : `(${ this.layoutService.translateText(ward.departmentTypeName) })`;
  }
}
